import { Stack, Typography } from '@mui/material';
import type { FieldElement } from '../../format/form-definition';
import { useBuilder } from '../context';
import { BoundInput } from './BoundInput';
import { CountBoundInput } from './CountBoundInput';
import { RuleExtras, RuleHead } from './RuleParts';
import { boundFields } from './rules';
import { END, ENDS, useRangeBounds } from './useRangeBounds';

export const RangeRule = ({ field }: { field: FieldElement }) => {
  const { form } = useBuilder();
  const { range, words, inputOf, change, noteOf, typeValue, leaving } = useRangeBounds(field);

  return (
    <Stack useFlexGap spacing={1.5} {...leaving}>
      <RuleHead name={words.name} />
      {words.bounds === 'count' ? (
        <Stack useFlexGap direction="row" spacing={1} sx={{ alignItems: 'baseline' }}>
          <CountBoundInput
            name={words[END.MIN]}
            input={inputOf(END.MIN)}
            note={noteOf(END.MIN)}
            onInput={input => change(END.MIN, input)}
          />
          <Typography color="text.secondary">–</Typography>
          <CountBoundInput
            name={words[END.MAX]}
            input={inputOf(END.MAX)}
            note={noteOf(END.MAX)}
            onInput={input => change(END.MAX, input)}
          />
        </Stack>
      ) : (
        <Stack useFlexGap spacing={1}>
          {ENDS.map(end => {
            const input = inputOf(end);
            return (
              <BoundInput
                key={end}
                field={field}
                name={words[end]}
                kind={words.bounds === 'date' ? 'date' : 'number'}
                input={input}
                note={noteOf(end)}
                fields={boundFields(form, field)}
                onInput={next => change(end, next)}
                onTypeValue={() => typeValue(end)}
              />
            );
          })}
        </Stack>
      )}
      {range && <RuleExtras field={field} validation={range} />}
    </Stack>
  );
};
